import { ActionType } from 'src/types/common/common';
import { ResponsiveTabAdaptor } from 'src/constrains/DraggableModules/Components';
import { dispatch } from '@/src/store';
import { onLoadData } from 'src/constrains/ResponsiveLayerEditor/slice';
import { generateTabPoster } from 'src/constrains/DraggableModules/tools';

const ResponsivePosterTabFunctions = ({
  onDynamicChange,
  onStaticChange,
  onModuleTypeChange,
  onCollapseOpen,
}) => {
  const handleOnTabItemChange = (id, index, modifiedData) => {
    if (onDynamicChange) {
      onDynamicChange({
        type: ActionType.modify,
        id,
        data: {
          index,
          modifiedData,
        },
      });
    }
  };
  const handleOnTabItemReselect = (id, images) => {
    // const _n = optionsToNum[posterType] || 1;
    // const _o = data || [generateResponsiveImage()];
    if (onDynamicChange) {
      onDynamicChange({ type: ActionType.reselect, id, data: images });
    }
  };

  const handleOnTabItemSort = (id, from, to) => {
    if (onDynamicChange) {
      onDynamicChange({
        type: ActionType.reorder,
        id,
        data: {
          from,
          to,
        },
      });
    }
  };

  const handleOnTabStaticChange = (id, data) => {
    if (onStaticChange) {
      onStaticChange({
        type: ActionType.modify,
        id,
        data,
      });
    }
  };

  const handleOnTabItemDelete = (id, index) => {
    if (onDynamicChange) {
      onDynamicChange({ type: ActionType.delete, id, data: { index } });
    }
  };

  const handleOnCloseAllCollapses = () => {
    if (onCollapseOpen) onCollapseOpen([]);
  };

  const handleOnTabModuleTypeChange = (data) => {
    if (onModuleTypeChange) {
      onModuleTypeChange(data);
    }
  };

  const handleOnTabItemAdd = (id, data) => {
    // const _n = optionsToNum[posterType] || 1;
    //
    const _o = data || [generateTabPoster()];
    if (onDynamicChange) {
      onDynamicChange({ type: ActionType.add, id, data: _o });
    }
  };

  const handleOnOpenImageTab = (data) => {
    //
    handleOnCloseAllCollapses();
    setTimeout(() => {
      dispatch(onLoadData(data));
    });
  };

  return {
    handleOnTabItemChange,
    handleOnTabItemSort,
    handleOnTabStaticChange,
    handleOnTabModuleTypeChange,
    handleOnOpenImageTab,
    handleOnTabItemReselect,
    handleOnTabItemAdd,
    handleOnTabItemDelete,
  };
};
const generateResponsivePosterTab = ({
  onDynamicChange,
  onStaticChange,
  onModuleTypeChange,
  onCollapseOpen,
}) => {
  const {
    handleOnTabItemChange,
    handleOnTabItemSort,
    handleOnTabStaticChange,
    handleOnTabModuleTypeChange,
    handleOnOpenImageTab,
    handleOnTabItemReselect,
    handleOnTabItemAdd,
    handleOnTabItemDelete,
  } = ResponsivePosterTabFunctions({
    onDynamicChange,
    onStaticChange,
    onModuleTypeChange,
    onCollapseOpen,
  });
  return {
    component: ResponsiveTabAdaptor,
    props: {
      onItemDelete: handleOnTabItemDelete,
      onItemChange: handleOnTabItemChange,
      onItemSort: handleOnTabItemSort,
      onStaticChange: handleOnTabStaticChange,
      onModuleTypeChange: handleOnTabModuleTypeChange,
      onOpenNewTab: handleOnOpenImageTab,
      onItemReselect: handleOnTabItemReselect,
      onItemAdd: handleOnTabItemAdd,
    },
  };
};
export { generateResponsivePosterTab };
